import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

import Input from "../../Components/Input";
import ActionNotifications from "../../Components/ActionNotifications";
import atlasLogo from "../../Assets/images/AtlasLogo-white.png";
import roboticVideo from "../../Assets/videos/RoboticVideo.mp4";
import "./styles.css";

import useAuth from "../../Hooks/useAuth";
import { isNewUser, checkRoles, isTokenValid } from "../../Utils/helper";

export default function LogInPage() {
  const auth = useAuth(),
    navigate = useNavigate(),
    [state, setState] = useState({
      email: "",
      emailError: false,
      password: "",
      passwordError: false,
      loading: false,
      WA: false,
      WAError: false,
      logout: false,
      notifications: [],
    });

  const tokenStr = localStorage.getItem("token");
  const userToken = JSON.parse(tokenStr);

  //comment this out for staging
  //only use for production site
  useEffect(() => {
    const onWindowsAuth = async () => {
      const response = await auth.loginWA();
      console.log(response);
      if (response.success) {
        navigate("/");
        window.location.reload();
      } else {
        console.log("login error");
        setState((state) => ({ ...state, WA: false }));
      }
    };
    onWindowsAuth();
  }, []);

  const onLoginInputChange = (e) => {
    const { name, value } = e.target;
    const inputNameError = `${name}Error`;
    let stateValues = { ...state };

    stateValues = { ...stateValues, [name]: value };

    if (name !== "") {
      stateValues = { ...stateValues, [inputNameError]: false };
    }

    if (state.loginFailed) {
      stateValues = {
        ...stateValues,
        emailError: false,
        passwordError: false,
        loginFailed: false,
      };
    }

    setState(stateValues);
  };

  const OnLoginFormClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    let stateValues = { ...state };

    if (stateValues.emailError || stateValues.passwordError) {
      stateValues.notifications.push({
        isMessageInGDStanding: false,
        message: "Please fix all error(s) before submitting.",
      });
    }

    if (stateValues.email === "") {
      stateValues = { ...stateValues, emailError: true };
      stateValues.notifications.push({
        isMessageInGDStanding: false,
        message: "Email is required.",
      });
      //this.props.onAddPostMessage('redBG', 'Email is required.');
    }

    if (stateValues.password === "") {
      stateValues = { ...stateValues, passwordError: true };
      stateValues.notifications.push({
        isMessageInGDStanding: false,
        message: "Password is required.",
      });
    }

    setState(stateValues);
    if (!stateValues.emailError && !stateValues.passwordError) {
      setState({ ...state, loading: true });

      const response = await auth.login(state.email, state.password);

      if (response.success) {
        if (!response.user.new) {
          console.log(isTokenValid());
          navigate("/");
          window.location.reload();
        } else {
          navigate("/login/new");
          window.location.reload();
        }
      } else {
        setState({
          ...state,
          loading: false,
          notifications: [].concat(state.notifications, response.errors),
        });
        console.log(response.errors);
      }
    }
  };
  return (
    <>
      {state.WA === false ? (
        <>
          <div id="LoginPage" className="inner">
            <ActionNotifications arrayOfToasts={state.notifications} />
            <div className="login">
              <div className="login-container">
                <div>
                  <img src={atlasLogo} alt="Atlas Logo" width="125" />
                </div>
                <h1>Welcome Back</h1>
                <p className="text">
                  Enter your credentials to accss your account
                </p>
                {/* the form for the inputs */}
                <form onSubmit={OnLoginFormClick}>
                  <div className="margin-email">
                    <Input
                      isError={state.emailError}
                      name="email"
                      onChange={onLoginInputChange}
                      value={state.email}
                      labelTitle="Email"
                      type="text"
                      autocomplete
                    />
                  </div>

                  <div className="margin-password">
                    <Input
                      isError={state.passwordError}
                      name="password"
                      onChange={onLoginInputChange}
                      value={state.password}
                      labelTitle="Password"
                      type="password"
                      autocomplete
                    />
                  </div>

                  <button type="submit" className="submit-btn">
                    {state.loading ? (
                      <FontAwesomeIcon
                        icon={faSpinner}
                        className="fa-spin"
                        size="lg"
                      />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </form>
                <div className="row g-0 text-center mt-md-2">
                  <div className="col-12 darkGray">
                    {" "}
                    <h5 className="noBold return">
                      Forgot your password?{" "}
                      <Link className="linkText yellow" to="reset">
                        Reset Password
                      </Link>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}
